const PREFIX = "thedrop:cwa:ageGate:";
/** Marks 21+ verified for this browser session (home browse + all shop routes). */
const SESSION_VERIFIED_KEY = `${PREFIX}session`;

export function ageGateStorageKey(dispensarySlug: string): string {
  return `${PREFIX}${dispensarySlug}`;
}

export function isSessionAgeVerified(): boolean {
  if (typeof sessionStorage === "undefined") {
    return false;
  }
  try {
    return sessionStorage.getItem(SESSION_VERIFIED_KEY) === "1";
  } catch {
    return false;
  }
}

function setSessionAgeVerified(): void {
  try {
    sessionStorage.setItem(SESSION_VERIFIED_KEY, "1");
  } catch {
    /* private mode / quota — gate will reappear next navigation */
  }
}

export function isAgeGateSatisfiedForSlug(dispensarySlug: string): boolean {
  if (isSessionAgeVerified()) {
    return true;
  }
  if (typeof sessionStorage === "undefined") {
    return false;
  }
  try {
    return sessionStorage.getItem(ageGateStorageKey(dispensarySlug)) === "1";
  } catch {
    return false;
  }
}

export function setAgeGateSatisfiedForSlug(dispensarySlug: string): void {
  setSessionAgeVerified();
  try {
    sessionStorage.setItem(ageGateStorageKey(dispensarySlug), "1");
  } catch {
    /* private mode / quota — gate will reappear next navigation */
  }
}
